// extracted by mini-css-extract-plugin
export default {"containerElections":"Election_containerElections__pUDoR","clubHeader":"Election_clubHeader__DbhGK","check":"Election_check__Wki1J"};